import { safeParse } from 'valibot'
import type { Nullable } from 'vite-node'
import { getJsonOrNullFromLocalStorage } from '../../../../lib/localStorage'
import { DeviceUserPreferenceSchema, type DeviceUserPreference } from './DeviceUserPreferenceSchema.type'
import { DEVICE_USER_PREFERENCE_LS_KEY } from './deviceUserPreferencesSignal'

export default function getDeviceUserPreferenceFromLocalStorage(): Nullable<DeviceUserPreference> {
  const result = safeParse(DeviceUserPreferenceSchema, getJsonOrNullFromLocalStorage(DEVICE_USER_PREFERENCE_LS_KEY))
  if (result.success) {
    return result.output
  }
}
